import qccapis  from "../../api/qcc";
import apis from "../../api/yj";
import flowapis from "../../api/flow";
import {dateUtils} from "../../utils/dateUtils";
import {utils} from "../../utils/utils";

export default {
    name: "LoanAudit",
    props: {
      visible: {
          type: Boolean, 
          require: false 
      },
      propsOne: String
    },
    data() {
        return {
            activeName:'first',
            activeNameZx:'first',
            scrollHeight:400,
            query: {
                userName: "",
            },
            isVisible:this.visible,

            //营业信息
            detailResult:{},
            caseResult:["","","",""],
            dataShow:false,
            sxdataList:[],
            sxdata:[],
            sxtype:0,
            labelList:["失信被执行","被执行","严重违法","裁判文书"],
            AllData:[[],[],[],[]],
            pageIndex:1,
            pageSize:10,
            mlShow:false,
            llTableData:[],
            cllTableData:[],
            llListResult:[],
            llShow:false,
            cllShow:false,
            llquery:false,
            fileList:[[],[],[],[],[],[],[],[],[],[]],
            FileTypeName:["工商信息登记","开户许可证","企业信用报告","营业执照","其他附件","夫妻双方征信","法人身份证照片","银行借款合同","相关保证、抵质押合同"],
            loanAudit:{},
            flowLogs:[],
        };
    },
    created() {
      // this.getBankList();
    },
    activated() {
    },
    mounted() {
      let that = this;
      that.calcTableHeight();
      // 注：window.onresize只能在项目内触发1次
      window.onresize = function windowResize () {
        that.calcTableHeight();
      }
    },
    methods: {
      getBankList(){
        let param= {
          state: "2",
          pageIndex: 0,
          pageSize: 0
         };
        apis.getBankList(param).then(res => {
         this.bankList=res.list
         })
      },
      onChangeClose(){
        let that = this
        this.isVisible = false
      },
      onChangeOpen(){
        this.isVisible = true
      },

      queryData(row){
        let that = this
        this.dataShow=false;
        this.errorflag=false;
        this.stepsStatus=1;
        if(row){
          that.flowInfo = utils.deepCopy(row)
          if(that.flowInfo.PersonFlag==1){
            that.activeNameZx = 'second'
          }else{
            that.activeNameZx = 'first'
          }
          // 查询营业执照
          const yyzz = qccapis.getCPDetail({id:row.CompanyCode})
          // 诉讼信息
          const ssxx = qccapis.getCPCase({id:row.CompanyCode})
          // 查询土地信息
          const llxx = qccapis.getLL({idCard:row.IdCard})

          // 查询审核信息 
          const shxx = apis.getYjFlowById({
             Id:that.flowInfo.Id,
            }
          )
          const fileInfo = flowapis.getLoanFiles({processId:that.flowInfo.Id,type:'',uploadType:'3'})
          var itemStore=null;
          Promise.all([yyzz, ssxx , llxx,shxx,fileInfo]).then((res) => {
            if(res.length===5){
              if(res[0]&&res[0]['Result']){
                that.detailResult = res[0]['Result']
              }else{
                that.detailResult = {}
              }
               if(res[2]){
                that.llTableData=res[2].list;
               }
              if(res[3]){
                  that.loanAudit = res[3]
                   if(that.loanAudit.JKTime){
                    that.loanAudit.SQJKQX=[that.loanAudit.JKTime,that.loanAudit.JKEndTime]
                  }
              }
              if(res[4]){
                  that.fileList=res[4];
               }
              var qccres=res[1];
              if(qccres){
                that.sxdata=res;
              for(var i=0;i<4;i++){
                  if(Number(qccres[i].Status)==200){
                    if(qccres[i].Result.VerifyResult==0)that.caseResult[i]=0;
                    else {
                      if(i<2)that.caseResult[i] = qccres[i].Paging.TotalRecords;
                      if(i==2)that.caseResult[i]=qccres[i].Result.Data.length;
                      if(i==3){
                        that.caseResult[i] = qccres[i].Paging.TotalRecords;
                       var datalist=qccres[3].Result.Data;
                        for(var j=0;j<datalist.length;j++){
                          var roletype="";
                          if(datalist[j].IsProsecutor)roletype="原告";
                          if(datalist[j].IsDefendant)roletype="被告";
                          datalist[j].RoleType=roletype;
                          var partylist=datalist[j].PartyList;
                          for(var k=0;k<partylist.length;k++){
                             if(partylist[k].RoleType==roletype){
                              datalist[j].Statement=partylist[k].Statement
                             }
                          }
                        }
                      }
                      that.AllData[i]=that.AllData[i].concat(qccres[i].Result.Data);
                      if(!that.dataShow){
                           that.dataShow=true;
                           that.sxtype=i;
                           that.sxdataList=that.getlistten(qccres[i].Result.Data,1,10);
                           if(that.caseResult[i]>10)that.mlShow=true;
                      }

                    }
                }else{
                  that.caseResult[i]="";
                }
               }
              }
            }
            
        if (this.$refs.ruleForm !== undefined) this.$refs.ruleForm.resetFields();
          })
        }
      },
      beforeAvatarFileUpload(file) {
        let that = this
        const isLt2M = file.size/1024/1024 <10
        if(!isLt2M){
            that.$message.error("上传文件大小不能超过10MB") 
            return false 
        }
        return true
      },
      uploadFileFile_FJ(item){
        let that = this
        let idx=item.data;
        let fileObj = item.file
        const form = new FormData()
        form.append("file",fileObj)
        apis.uploadFile(form).then(res => {
            that.fileList[idx].push({
              name: that.getFileName(res.fullPath),
              url:res.fullPath
            })
        });
      },
      getFileName(path){
        var pos1 = path.lastIndexOf('/');
        var pos2 = path.lastIndexOf('\\');
        var pos  = Math.max(pos1, pos2)
        if( pos<0 )
            return path;
        else
            return path.substring(pos+1);
      },
      handleFileRemove_FJ(file) {
        let that = this
        if(file){
          for(let i=0;i<that.fileList.length;i++){
            for(let j=0;j<that.fileList[i].length;j++){
              if(file.url===that.fileList[i][j].url){
                that.fileList[i].splice(j,1)
              }
            }
            
          }
        }
      },
      handleFileView(url){
            window.open(url);
      },
      handleExceed(){
        this.$message.error("数量超出限制，请先移除原有文件");
      },

      /**
       * 保存文件
       */
      saveFjFileInfo(callback){
        let that = this
        let filesLists = []
        console.log(that.fileList.length)
        for(var i=0;i<that.fileList.length;i++){
          console.log(i)
          let fileInfo = {
            ProcessId:that.flowInfo.Id,
            Type:'2',
            Url:that.fileList[i]['url'],
            Name:that.fileList[i]['name'],
            UploadType:2
          }
          filesLists.push(fileInfo)
        }
        if(filesLists.length>0){
          flowapis.addLoanFile({fileList:filesLists}).then(res => {
            callback(res)
          })
        }else{
            callback(true)
        }
      },

      // 信用相关
      queryClick(flag){
        this.dataShow=true;
        this.sxtype=flag;
        if(this.caseResult[flag]>10)this.mlShow=true;
        else this.mlShow=false;
        this.pageIndex=1;
        this.sxdataList=this.getlistten(this.AllData[flag],1,10);
      },
      getlistten(list,pageIndex,pageSize){
        var newlist=[]
        for(var i=0;i<pageSize;i++){
          var j=i+(pageIndex-1)*pageSize;
          if(j<list.length)newlist.push(list[j]);
        }
        return newlist;
      },
      getList(flag){
        var type=this.sxtype;
        var that=this;
        var pageIndex=this.pageIndex+flag;
        if(pageIndex<1){that.$message.info("已经是第一页");return;}
        var allPage=(this.caseResult[this.sxtype]+9)/10;
        if(pageIndex>allPage){that.$message.info("已经是最后一页");return;};
        if(this.sxtype==2){
          this.pageIndex=pageIndex;
          this.sxdataList=this.getlistten(this.AllData[type],pageIndex,10);
        }else{
          let param1 = {
              id:that.flowInfo.Code,
              pageIndex:Math.ceil(pageIndex/2),
              type:Number(type)+1
           }
           
           qccapis.getCPCaseByType(param1).then(res => {
          if(res!=null){
            if(Number(res.Status)==200){
                var datalist=res.Result.Data;
                if(type==3){
                  for(var j=0;j<datalist.length;j++){
                    var roletype="";
                    if(datalist[j].IsProsecutor)roletype="原告";
                    if(datalist[j].IsDefendant)roletype="被告";
                    datalist[j].RoleType=roletype;
                    var partylist=datalist[j].PartyList;
                    for(var k=0;k<partylist.length;k++){
                       if(partylist[k].RoleType==roletype){
                        datalist[j].Statement=partylist[k].Statement
                       }
                    }
                  }
                }
                var danwei=pageIndex%2;
                if(danwei==0)danwei=2;
                that.pageIndex=pageIndex;
                var list=that.getlistten(res.Result.Data,danwei,10);
                that.sxdataList=list;
              }else{
               that.$message.error(res[i].Message)
              }
            }else{
             that.$message.error("查询信息失败")
           }
            });


        }
      },
      /**
       * 暂存在本地缓存中
       */
      onSaveLocalStore(){
        let that = this
        that.dynamicSaveItems()
      },

      /**
       * 银行拒绝
       * 
       */
      onReturnFlow(){
        let that = this
        this.$prompt('', '必须填写拒绝的原因', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: '必须填写原因',
          inputValidator:(value)=>{
            if(value.trim().length<1){
              return false
            }
          },
          beforeClose: (action, instance, done)=>{
            if(action == 'confirm'){
                let value = instance.inputValue
                if(value.length>200){
                  that.$message({
                    message: '理由应不超过200字',
                    type: "error"
                  });
                  return
                }
                if(value && value != ''){
                  let param = {
                    Id:that.loanAudit.Id,
                    Route:that.loanAudit.Route,
                    State:5,
                    RefuseReason:value,
                  }
                  if(that.loanAudit.Route<3||that.loanAudit.Route==6)param.State=3
                  apis.updateYjFlow(param).then((res) => {
                    if(res){
                      done()
                    }else{
                      that.$message({
                        message: '拒绝失败请重试',
                        type: "error"
                      });
                    }
                  })
                }
            }else{
              done()
            }
          }
        }).then(({ value }) => {
            that.onChangeClose()
            that.$parent.bankAuditSucess();
        }).catch(() => {
               
        });
      },
      onPassFlow(){
        var that=this;
        let param = {
          Id:that.loanAudit.Id,
          Route:3,
          State:1
        }//初审
        if(that.loanAudit.Route==2&&that.loanAudit.NewRoute==0){
          param.Route=21;//复审
        }
        if(that.loanAudit.Route==3)param.Route=4;//复审
        if(that.loanAudit.Route==4)param.Route=5;
        // if(that.loanAudit.Route==5){param.Route=6;param.State=4;}//担保复审
         if(that.loanAudit.Route==6){param.Route=7;param.State=2;}//担保终审
        apis.updateYjFlow(param).then((res) => {
          if(res){
            if(res=="success"){
              that.onChangeClose()
             that.$parent.bankAuditSucess();
         
            }else{
              that.$message({
              message: res,
              type: "error"
             });
            }
            
          }else{
            that.$message({
              message: '提交失败请重试',
              type: "error"
            });
          }
        })
      },
      onRollBacklow(){
        let that = this
        this.$prompt('', '必须填写退回的原因', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: '必须填写原因',
          inputValidator:(value)=>{
            if(value.trim().length<1){
              return false
            }
          },
          beforeClose: (action, instance, done)=>{
            if(action == 'confirm'){
                let value = instance.inputValue
                if(value && value != ''){
                  if(value.length>200){
                    that.$message({
                      message: '理由应不超过200字',
                      type: "error"
                    });
                    return
                  }
                  if(value && value != ''){
                    let param = {
                      Id:that.loanAudit.Id,
                      Route:1,
                      State:1,
                      ReturnReason:value,
                    }
                    apis.updateYjFlow(param).then((res) => {
                      if(res){
                        done()
                      }else{
                        that.$message({
                          message: '拒绝失败请重试',
                          type: "error"
                        });
                      }
                    })
                  }
                }
            }else{
              done()
            }
          }
        }).then(({ value }) => {
          that.onChangeClose()
          that.$parent.bankAuditSucess();
        }).catch(() => {
               
        });
      },
      setObjEmptyToNull(obj){
        Object.keys(obj).forEach(function(key, index) {
          if (this[key] === '') this[key] = null;
        }, obj);
        return obj
      },
      calcTableHeight(){
        this.$nextTick(() => {
          var height1=$(".content-box .content").height();
          var height=height1-50-20-40-20;
          this.scrollHeight = height;
        });
      },
    },
  };
